import React, { useMemo } from 'react'
import Transition from 'components/atoms/Transition'
import StyledActionsDialog from 'components/atoms/StyledActionsDialog'
import StyledModalDialog from 'components/atoms/StyledModalDialog'
import { Button } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import {
  DialogContent,
  DialogTitle,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core'
import { normalizeAccessCode } from 'utils/helpers'

dayjs.extend(isBetween)

export default function AccessCodeHistory({
  open,
  handleClose,
  date,
  codeNum,
  dateFormat,
  codesHistory,
  intercomUuids,
  ...props
}) {
  const { t } = useTranslation(['keys', 'common', 'devices'])
  const datetimeFormat = 'HH:mm:ss'
  const intercoms = useSelector(({ devicesNew }) => devicesNew.intercoms)

  // Плоский список открытий выбранным кодом за выбранные сутки:
  // один и тот же код может быть заведён на несколько панелей подъезда.
  const openings = useMemo(() => {
    if (!open || !date) return []

    const dayStart = date.startOf('day')
    const dayEnd = date.endOf('day')
    const result = []

    Object.entries(codesHistory).forEach(([uuid, info]) => {
      Object.entries(info).forEach(([code, timestamps]) => {
        if (normalizeAccessCode(code) !== normalizeAccessCode(codeNum)) return
        if (!Array.isArray(timestamps)) return

        const intercom = intercoms?.find((inter) => inter?.uuid === uuid)

        timestamps.forEach((time) => {
          if (!dayjs(time).isBetween(dayStart, dayEnd)) return

          result.push({
            time,
            intercom: intercom?.serial_number || uuid,
          })
        })
      })
    })

    return result.sort(
      (a, b) => dayjs(b.time).valueOf() - dayjs(a.time).valueOf()
    )
  }, [codesHistory, open, codeNum, intercoms, date])

  return (
    <StyledModalDialog
      open={open}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{
        style: { borderRadius: 20, maxHeight: '100vh' },
      }}
      {...props}
    >
      <DialogTitle>
        {t('keys:units.access_code')}: {codeNum}
      </DialogTitle>

      <div
        style={{
          color: '#6e6d7a',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {t('common:date')}: {date.format(dateFormat)}
      </div>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('devices:units.intercom')}</TableCell>
              <TableCell>{t('keys:access_code.history.time')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {openings.map(({ time, intercom }) => (
              <TableRow key={`${intercom}-${time}`}>
                <TableCell>{intercom}</TableCell>
                <TableCell>{dayjs(time).format(datetimeFormat)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <StyledActionsDialog>
        <Button onClick={handleClose} tertiary>
          {t('devices:video_archive.back')}
        </Button>
      </StyledActionsDialog>
    </StyledModalDialog>
  )
}
